import { useCallback, useContext, useMemo, useState } from 'react';
import { useFloating } from '@floating-ui/react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { cx } from '@trinity/chat-components';
import { Portal } from '@trinity/chat-components/components/Portal/index.js';
import { useZIndexMiddleware } from '@trinity/chat-components/components/presentation/popper-modifiers.js';
import { AdditionalFiltersMenu } from './AdditionalFilters.Menu';
import { ProjectClipsFiltersContext } from './context';
import { Filter } from './Filter.Icon';

export const AdditionalFilters = () => {
  const filters = useContext(ProjectClipsFiltersContext);

  const [filterMenuOpen, setFilterMenuOpen] = useState(false);

  const hasAdditionalFilters = useMemo(() => {
    return filters.groupTagIds.length > 0 || filters.speakerRole !== 'all';
  }, [filters.speakerRole, filters.groupTagIds]);

  const zIndexMiddleware = useZIndexMiddleware();
  const { refs, floatingStyles } = useFloating({
    open: filterMenuOpen,
    onOpenChange: setFilterMenuOpen,
    middleware: [
      zIndexMiddleware,
    ],
    placement: 'bottom-start',
  });

  const handleBlur = useCallback(() => {
    setFilterMenuOpen(false);
  }, []);

  const handleFilterClick = useCallback(() => {
    setFilterMenuOpen(true);
  }, []);

  return (
    <>
      <div
        ref={refs.setReference}
        onClick={handleFilterClick}>
        <Filter
          isActive={hasAdditionalFilters} />
      </div>
      {filterMenuOpen &&
        <Portal>
          <ClickAwayListener
            mouseEvent='onMouseDown'
            onClickAway={handleBlur}
            touchEvent='onTouchStart'>
            <div
              ref={refs.setFloating}
              style={floatingStyles}>
              <AdditionalFiltersMenu onClose={handleBlur} />
            </div>
          </ClickAwayListener>
        </Portal>
      }
    </>
  );
};